import { render, staticRenderFns } from "./ParagraphHierarchicalBlock.vue?vue&type=template&id=f2327048&scoped=true&"
import script from "./ParagraphHierarchicalBlock.vue?vue&type=script&lang=js&"
export * from "./ParagraphHierarchicalBlock.vue?vue&type=script&lang=js&"
import style0 from "./ParagraphHierarchicalBlock.vue?vue&type=style&index=0&id=f2327048&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2327048",
  null
  
)

export default component.exports